import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Form,
  Button,
  Card,
  Container,
  Row,
  Col,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import Layout from "../../components/Layout";
import axios from "axios";
import { BASE_URL } from "../../constants";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const UpdateShelter = () => {
  const shelterId = JSON.parse(localStorage.getItem("userData"))?.shelter?.id;
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    address: {
      street: "",
      city: "",
   
      postalCode: "",
      country: "",
    },
    contactInfo: {
      phone: "",
      email: "",
    },
    costPerOccupant: "",
    stateCoverage: "",
  });

  const [loading, setLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const fetchShelter = async () => {
      try {
        const { data } = await axios.get(`${BASE_URL}/shelters/${shelterId}`);
        setFormData({
          ...data,
          address: {
            street: data.address?.street || "",
            city: data.address?.city || "",
            
            postalCode: data.address?.postalCode || "",
            country: data.address?.country || "",
          },
          contactInfo: {
            phone: data.contactInfo?.phone || "",
            email: data.contactInfo?.email || "",
          },
        });
      } catch (err) {
        setToastMessage("Failed to load shelter data");
        setShowToast(true);
      }
    };
    fetchShelter();
  }, [shelterId]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (["street", "city", "postalCode", "country"].includes(name)) {
      setFormData((prev) => ({
        ...prev,
        address: {
          ...prev.address,
          [name]: value,
        },
      }));
    } else if (["phone", "email"].includes(name)) {
      setFormData((prev) => ({
        ...prev,
        contactInfo: {
          ...prev.contactInfo,
          [name]: value,
        },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setToastMessage("");

    try {
      await axios.put(`${BASE_URL}/shelters/${shelterId}`, formData);
      setToastMessage("Shelter updated successfully!");
      setShowToast(true);
      setTimeout(() => navigate("/admin/dashboard"), 3000);
    } catch (err) {
      setToastMessage(
        err.response?.data?.message || "Failed to update shelter"
      );
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Container className="py-5 d-flex justify-content-center">
        <Card className="p-4 shadow-sm rounded-4" style={{ width: "100%", maxWidth: "900px" }}>
          <h4 className="mb-4 fw-semibold">Update Shelter</h4>

          <Form onSubmit={handleSubmit}>
            <Row className="g-3">
              <Col md={12}>
                <Form.Group controlId="formName">
                  <Form.Label className="small fw-semibold">Shelter Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Shelter Name"
                  />
                </Form.Group>
              </Col>

              {/* One-Line Structured Address */}
              <Col md={12}>
                <Form.Label className="small fw-semibold">Address</Form.Label>
                <Row className="g-2">
                  <Col md={3}>
                    <Form.Control
                      type="text"
                      name="street"
                      value={formData.address.street}
                      onChange={handleChange}
                      placeholder="Street"
                    />
                  </Col>
                  <Col md={2}>
                    <Form.Control
                      type="text"
                      name="city"
                      value={formData.address.city}
                      onChange={handleChange}
                      placeholder="City"
                    />
                  </Col>
                  
                  <Col md={2}>
                    <Form.Control
                      type="text"
                      name="postalCode"
                      value={formData.address.postalCode}
                      onChange={handleChange}
                      placeholder="Postal Code"
                    />
                  </Col>
                  <Col md={3}>
                    <Form.Control
                      type="text"
                      name="country"
                      value={formData.address.country}
                      onChange={handleChange}
                      placeholder="Country"
                    />
                  </Col>
                </Row>
              </Col>

              {/* Contact Info */}
              <Col md={6}>
                <Form.Group controlId="formPhone">
                  <Form.Label className="small fw-semibold">Phone</Form.Label>
                  <PhoneInput
                    country={"de"}
                    value={formData.contactInfo.phone}
                    onChange={(phone) =>
                      setFormData((prev) => ({
                        ...prev,
                        contactInfo: { ...prev.contactInfo, phone },
                      }))
                    }
                    inputClass="form-control"
                    inputStyle={{ width: "100%" }}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId="formEmail">
                  <Form.Label className="small fw-semibold">Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.contactInfo.email}
                    onChange={handleChange}
                    placeholder="Email Address"
                  />
                </Form.Group>
              </Col>

              {/* Cost and Coverage */}
              <Col md={6}>
                <Form.Group controlId="formCost">
                  <Form.Label className="small fw-semibold">Cost per Occupant</Form.Label>
                  <Form.Control
                    type="number"
                    name="costPerOccupant"
                    value={formData.costPerOccupant}
                    onChange={handleChange}
                    placeholder="e.g. 100"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId="formCoverage">
                  <Form.Label className="small fw-semibold">State Coverage (%)</Form.Label>
                  <Form.Control
                    type="number"
                    name="stateCoverage"
                    value={formData.stateCoverage}
                    onChange={handleChange}
                    placeholder="e.g. 50"
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end mt-4">
            <Button
  variant="info"
  className="rounded-pill px-4 py-2 fw-semibold"
  type="submit"
  disabled={loading || !formData.name}
>
{loading ? (
    <span
      className="spinner-border spinner-border-sm me-2"
      role="status"
      aria-hidden="true"
    ></span>
  ) : (
    "Save Changes"
  )}
</Button>
            </div>
          </Form>
        </Card>

        <ToastContainer position="top-end" className="p-3">
          <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide bg="success">
            <Toast.Body className="text-white">{toastMessage}</Toast.Body>
          </Toast>
        </ToastContainer>
      </Container>
    </Layout>
  );
};

export default UpdateShelter;
